export default "__VITE_ASSET__BV6VtAT4__"